<script setup>
    import { useAvailablePaymentMethods } from '@/composables/front/checkout/useAvailablePaymentMethods.js';
    import PaymentStep from '@/modules/front/checkout/PaymentStep.vue';

    const props = defineProps({
        jet_id: {
            type: String,
            required: true
        },
        session_id: {
            type: String,
            default: ''
        },
        tipo_venta: {
            type: String,
            default: 'evento'
        },
        esPlazos: {
            type: Boolean,
            default: false
        },
        importeCarrito: {
            type: Number,
            default: 0
        },
        gastosGestionUnitarios: {
            type: Number,
            default: 0
        },
        numAbonados: {
            type: Number,
            default: 1
        },
        store: {
            type: Object,
            default: null
        },
        getVuexAlias: {
            type: Function,
            default: null
        }
    });

    const emit = defineEmits(['payToken', 'bizumError', 'retry']);

    // Method availability (whitelist-gated Instant Credit, plazos rule, etc.) still
    // lives here; PaymentStep owns the A/B visual state machine on top of it.
    const { methods } = useAvailablePaymentMethods({
        store: props.store,
        esPlazos: props.esPlazos,
        importeCarrito: props.importeCarrito,
        tipoVenta: props.tipo_venta
    });

    const onPayToken = jetToken => emit('payToken', jetToken);
    const onBizumError = msg => emit('bizumError', msg);
    // Legacy cancel behaviour: the card form's "cancelar compra" reloads the step.
    const onCancel = () => window.location.reload();
</script>

<template>
    <div class="container" data-test="formulario-pago">
        <PaymentStep
            :methods="methods"
            :jet_id="jet_id"
            :session_id="session_id"
            :tipo_venta="tipo_venta"
            :es-plazos="esPlazos"
            :importe-carrito="importeCarrito"
            :gastos-gestion-unitarios="gastosGestionUnitarios"
            :num-abonados="numAbonados"
            :store="store"
            :get-vuex-alias="getVuexAlias"
            @payToken="onPayToken"
            @bizumError="onBizumError"
            @cancel="onCancel"
        />
    </div>
</template>
